export const ExodusResources = {
    PATIENT: '/api/Patient',
    PATIENT_ACCOUNT: '/api/Patient/myaccount'
};



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/shared/urls/exodus.resource.ts